import { Grid } from "@mui/joy";

import { Autocomplete, TextField, UserDropdown } from "../../../../../shared";

export default function ProjectStep() {
    return (
        <Grid container spacing={2}>
            <Grid xs={12}>
                <TextField
                    name="name"
                    label="Project Name"
                    helperText="Auto-filled from customer name and address — edit anytime"
                    placeholder="e.g., Jane Doe — 123 Main St, Denver, CO"
                />
            </Grid>
            <Grid xs={12} sm={6}>
                <Autocomplete
                    options={["Residential", "Commercial", "Industrial", "Multifamily"]}
                    name="type"
                    label="Type"
                    placeholder="e.g., Residential, Commercial"
                    helperText="Select the project category"
                />
            </Grid>
            <Grid xs={12} sm={6}>
                <UserDropdown
                    name="salesmanName"
                    label="Salesman"
                    helperText="Assigned sales representative"
                    placeholder="Select salesman"
                />
            </Grid>
        </Grid>
    );
}
